var FixedHeader = {
    prevScroll:0,
    init:function(){
        document.addEventListener("scroll", function(){
            FixedHeader.scroll();
        });
        FixedHeader.scroll();
    },
    scroll:function(){
        if(window.scrollY <= 0){
            document.querySelector(".shopify-section-header-sticky").classList.add("on-top");
            document.querySelector(".shopify-section-header-sticky").classList.remove("scroll-down");
        }else{
            
            document.querySelector(".shopify-section-header-sticky").classList.remove("on-top");
            
            if(window.scrollY < FixedHeader.prevScroll){
                document.querySelector(".shopify-section-header-sticky").classList.add("scroll-up");
                document.querySelector(".shopify-section-header-sticky").classList.remove("scroll-down");
            }else{
                document.querySelector(".shopify-section-header-sticky").classList.remove("scroll-up");
                document.querySelector(".shopify-section-header-sticky").classList.add("scroll-down");
            }

            FixedHeader.prevScroll = window.scrollY;
        }
    }
}

window.addEventListener("load", function(){
    if(document.querySelectorAll(".shopify-section-header-sticky").length > 0){
        FixedHeader.init();
    }
})